export function categoryIdsMatch(a, b) {
  return a != null && b != null && String(a) === String(b);
}

export function mergeCategoryIntoList(list, category) {
  if (!category?.id) return list;
  if (list.some((item) => categoryIdsMatch(item.id, category.id))) {
    return list;
  }
  return [category, ...list];
}

const PREVIEW_CATEGORY_LIMIT = 8;

export function splitCategoriesForPreview(allCategories, selectedCategoryId, visibleLimit = PREVIEW_CATEGORY_LIMIT) {
  const naturalPreview = allCategories.slice(0, visibleLimit);
  const naturalExtra = allCategories.slice(visibleLimit);

  if (!selectedCategoryId) {
    return { preview: naturalPreview, extra: naturalExtra };
  }

  const selectedInPreview = naturalPreview.some((c) => categoryIdsMatch(c.id, selectedCategoryId));
  if (selectedInPreview) {
    // Already visible — keep order stable
    return { preview: naturalPreview, extra: naturalExtra };
  }

  // Selected is in the extra section — bring it to the front
  const selected = allCategories.find((c) => categoryIdsMatch(c.id, selectedCategoryId));
  if (!selected) {
    return { preview: naturalPreview, extra: naturalExtra };
  }

  const rest = allCategories.filter((c) => !categoryIdsMatch(c.id, selectedCategoryId));
  const preview = [selected, ...rest.slice(0, PREVIEW_CATEGORY_LIMIT - 1)];
  const previewIds = new Set(preview.map((c) => String(c.id)));
  const extra = allCategories.filter((c) => !previewIds.has(String(c.id)));
  return { preview, extra };
}
